

import React, { useEffect, useState, useRef } from 'react'
import { useAuth } from '../../context/auth'
import { Navigate, useNavigate } from 'react-router-dom'
import { useWebSocket } from '../../context/UseWebSocketContext'
import { toast } from 'react-toastify'

const ProtectedRoutes = ({ children }) => {

  const { getLoginToken, getGoogleAuthToken } = useAuth()
  const token = getLoginToken();
  const gtoken = getGoogleAuthToken();
  
  const navigate = useNavigate()
  const { closeWebSocket, errorMessage, setErrorMessage } = useWebSocket()
  
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  
  // ✅ Use ref to prevent multiple redirects
  const hasRedirected = useRef(false)
  const errorProcessed = useRef(false)

  // ✅ Check authentication
  useEffect(() => {
    const hasToken = token && token !== "" && token !== "undefined" && token !== "null" && token.length > 10
    const hasGToken = gtoken && gtoken !== "" && gtoken !== "undefined" && gtoken !== "null" && gtoken.length > 10
    
    console.log("🔐 ProtectedRoutes - Token check:", { hasToken, hasGToken, tokenLength: token?.length })
    
    if (hasToken || hasGToken) {
      setIsAuthenticated(true)
    } else {
      setIsAuthenticated(false)
    }
    
    setIsLoading(false)
  }, [token, gtoken])

  // ✅ Handle 401 - Access Denied (FIXED - no infinite loop)
  useEffect(() => {
    if (errorMessage === "Access denied!" && !errorProcessed.current) {
      errorProcessed.current = true
      console.log("❌ 401 - Access Denied! Redirecting to login...")
      toast.error("Session expired! Please login again.")
      
      // Clear all storage
      localStorage.clear()
      sessionStorage.clear()
      
      // Close WebSocket
      if (closeWebSocket) closeWebSocket()
      
      // Clear error message
      setErrorMessage("")
      
      // Redirect to login
      navigate("/login", { replace: true })
      
      // Reset after 2 seconds
      setTimeout(() => {
        errorProcessed.current = false
      }, 2000)
    }
  }, [errorMessage, navigate, setErrorMessage, closeWebSocket])

  // ✅ Handle 429 - Too Many Requests
  useEffect(() => {
    if (errorMessage === "Too Many Request Try Again!") {
      console.log("⚠️ 429 - Too Many Requests!")
      toast.warning("Too many requests! Please wait a moment.")
      setTimeout(() => setErrorMessage(""), 3000)
    }
  }, [errorMessage, setErrorMessage])

  // ✅ Show loading spinner
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900 z-50">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          <p className="text-gray-600 dark:text-gray-400 text-sm">Checking authentication...</p>
        </div>
      </div>
    )
  }

  // ✅ Redirect to login if not authenticated
  if (!isAuthenticated && !hasRedirected.current) {
    hasRedirected.current = true
    console.log("🚪 Not authenticated, redirecting to login")
    return <Navigate to="/login" replace />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoutes